module.exports = __webpack_public_path__ + "static/bfb-video-poster-ea41b610224f8c2f02d4f3eda794d869.jpg";